import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoFocusDirective } from './auto-focus.directive';
import { BusyIfDirective } from './busy-if.directive';
import { ButtonBusyDirective } from './button-busy.directive';
import { FileDownloadService } from './file-download.service';
import { FriendProfilePictureComponent } from './friend-profile-picture.component';
import { MomentFormatPipe } from './moment-format.pipe';
import { ValidationMessagesComponent } from './validation-messages.component';
import { EqualValidator } from './validation/equal-validator.directive';
import { MinValueValidator } from './validation/min-value-validator.directive';
import { PasswordComplexityValidator } from './validation/password-complexity-validator.directive';
import { NullDefaultValueDirective } from './null-value.directive';
import { ReplacePipe } from './replace.pipe';
import { GroupByPipe } from './group-by.pipe';

import { AutocompleteDirective } from './autocomplete.directive';
import { EmailMultipleDirective } from './email-multiple.directive';
import { MaskIfNotLoggedInDirective } from './mask-if-not-logged-in.directive';
import { PermissionDirective } from './permission.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        FileDownloadService,
    ],
    declarations: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        ReplacePipe,GroupByPipe,
        AutocompleteDirective,
        EmailMultipleDirective,
        MaskIfNotLoggedInDirective,
        PermissionDirective
    ],
    exports: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        ValidationMessagesComponent,
        NullDefaultValueDirective,
        ReplacePipe,GroupByPipe,
        AutocompleteDirective,
        EmailMultipleDirective,
        MaskIfNotLoggedInDirective,
        PermissionDirective
    ]
})
export class UtilsModule { }
